/**
 * Created by xiaoyun on 17/2/21.
 */
import webapi from '../../request/webapi';
import * as utils from '../utils';
import { unfreezedRepayIdCoupon } from '../common/coupon';

const mixinRepay = {
  methods: {
    // 询问支付是否成功
    payConfirm() {
      this.$showDialog({
        show: true,
        text: '支付是否成功?',
        buttons: [{
          text: '遇到问题',
          color: 'grey',
          event: async () => {
            // 遇到问题埋点
            this.$reportLog('payConfirm_1', 'btn', '遇到问题');
            await unfreezedRepayIdCoupon();
            this.$router.push({ name: 'helpList', params: { id: 'repay' } });
            this.$hideDialog();
          }
        }, {
          text: '支付成功',
          color: '',
          event: async () => {
            // 支付成功埋点
            this.$reportLog('payConfirm_2', 'btn', '支付成功');
            await unfreezedRepayIdCoupon();
            this.$router.go(-1);
            this.$hideDialog();
          }
        }]
      });
    },
    // 创建还款申请单
    async createRepayApply(type) {
      if (!this.repayApplyId) {
        this.$hideLoader({ text: '正在处理中...' });
        try {
          let result = await webapi.repay.apply({
            repayType: type,
            withdrawApplyNo: this.repayInfo.withdrawApplyNo,
            amount: this.shouldPay,
            coreAccountRequestId: this.repayInfo.coreAccountRequestId
          });
          if (result.statusCode !== 200) {
            this.$showToast({ text: result.message || '还款申请失败，请稍后重试' });
            return Promise.reject(result.message);
          }
          this.repayApplyId = result.result.repayApplyId;
          this.jieaLoanId = result.result.jieaLoanId;
          // 设置或者获取--repayApplyId
          console.log('设置或者获取repayApplyId--->', this.repayApplyId);
          utils.localCache('repayApplyId', result.result.repayApplyId);
        }
        catch (e) {
          console.log(e);
          this.$showToast({ text: '还款申请失败，请稍后重试' });
        }
        finally {
          this.$hideLoader();
        }
      }
    },
    // 使用账户余额进行还款，type: 还款方式 1 正常还款  /  2 提前结清
    async repayWithAccount(type) {
      this.$showLoader({ text: '正在还款中，请稍后' });
      try {
        let result;
        if (type === 1) {
          result = await webapi.repay.normal({
            coreAccountRequestId: this.repayInfo.coreAccountRequestId,
            repayId: this.repayApplyId,
            deductId: 0
          });
        }
        else {
          result = await webapi.repay.prepay({
            coreAccountRequestId: this.repayInfo.coreAccountRequestId,
            repayId: this.repayApplyId
          });
        }
        console.log('使用账户余额进行还款，result', JSON.stringify(result));
        if (result && result.statusCode === 200) {
          this.$showToast({ text: '还款成功！' });
          return this.$router.replace({ name: 'repayDetail', params: { id: this.repayInfo.withdrawid } });
        }
        return this.$showToast({ text: '还款失败，请您稍后重试！' });
      }
      catch (e) {
        console.log('还款失败，请您稍后再试，error', e);
        return this.$showToast({ text: '还款失败，请您稍后再试！' });
      }
      finally {
        this.$hideLoader();
      }
    },
    // 使用红包进行还款
    async couponRepay() {
      this.$showLoader({ text: '正在还款中，请稍后' });
      try {
        console.log('repayApplyIdrepayApplyId', this.repayApplyId);
        const result = await webapi.coupon.couponPayment({
          coreAccountCustomerId: this.repayInfo.coreAccountCustomerId,
          repayApplyId: this.repayApplyId,
          couponId: parseInt(Number(this.coupon.couponId), 10),
          couponDispatch: 1
        });
        if (result.statusCode && result.statusCode === 200) {
          this.$showToast({ text: '红包支付成功！' });
          return this.$router.replace({ name: 'repayDetail', params: { id: this.repayInfo.withdrawid } });
        }
        return this.$showToast({ text: '红包支付失败，请您稍后重试！' });
      }
      catch (e) {
        return this.$showToast({ text: '红包支付失败，请您稍后重试！' });
      }
      finally {
        this.$hideLoader();
      }
    }
  }
};
export { mixinRepay };
